<div *ngIf="(loaderService.loading$ | async)" class="loader-container">
    <!-- <div class="sk-folding-cube "> -->
    <!--     <div class="sk-cube1 sk-cube"></div> -->
    <!--     <div class="sk-cube2 sk-cube"></div> -->
    <!--     <div class="sk-cube4 sk-cube"></div> -->
    <!--     <div class="sk-cube3 sk-cube"></div> -->
    <!-- </div> -->
    <img width="100px" [ngClass]="currentImageClass" [src]="'assets/images/icons/'+currentImage+'.svg'">
    <div class="loader-text line-1 anim-typewriter" *ngIf="isReady">
        {{currentValue}}
    </div>
</div>